import { useCallback, useState } from 'react';
import SteppedModal from 'components/SteppedModal';

export interface UseSocialShareModalStepsProps {
  modalRef: React.RefObject<SteppedModal>;
}

export interface UseSocialShareModalStepsResult {
  activeStep: string;
  goToStep: (step: string) => void;
}

export default function useSocialShareModalSteps({
  modalRef,
}: UseSocialShareModalStepsProps): UseSocialShareModalStepsResult {
  const [activeStep, setActiveStep] = useState<string>('');

  const handleGoToStep = useCallback(
    (step: string) => {
      setActiveStep(step);
      modalRef.current?.stepHistory.replace(step);
    },
    [modalRef],
  );

  return {
    activeStep,
    goToStep: handleGoToStep,
  };
}
